export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const CREATE_START = 'CREATE_START';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAILURE = 'CREATE_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const FILES_START = 'FILES_START';
export const FILES_SUCCESS = 'FILES_SUCCESS';
export const FILES_FAILURE = 'FILES_FAILURE';

export const DETECTION_RULES_START = 'DETECTION_RULES_START';
export const DETECTION_RULES_SUCCESS = 'DETECTION_RULES_SUCCESS';
export const DETECTION_RULES_FAILURE = 'DETECTION_RULES_FAILURE';

export const MAIL_DESTINATIONS_START = 'MAIL_DESTINATIONS_START';
export const MAIL_DESTINATIONS_SUCCESS = 'MAIL_DESTINATIONS_SUCCESS';
export const MAIL_DESTINATIONS_FAILURE = 'MAIL_DESTINATIONS_FAILURE';

export const ACTION_START = 'ACTION_START';
export const ACTION_SUCCESS = 'ACTION_SUCCESS';
export const ACTION_FAILURE = 'ACTION_FAILURE';

export const UPDATE_START = 'UPDATE_START';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const EVENT_LOG_START = 'EVENT_LOG_START';
export const EVENT_LOG_SUCCESS = 'EVENT_LOG_SUCCESS';
export const EVENT_LOG_FAILURE = 'EVENT_LOG_FAILURE';

export const WORK_LOG_START = 'WORK_LOG_START';
export const WORK_LOG_SUCCESS = 'WORK_LOG_SUCCESS';
export const WORK_LOG_FAILURE = 'WORK_LOG_FAILURE';

export const UPLOAD_FILE_START = 'UPLOAD_FILE_START';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';

export const UPLOAD_FILES_START = 'UPLOAD_FILES_START';
export const UPLOAD_FILES_SUCCESS = 'UPLOAD_FILES_SUCCESS';
export const UPLOAD_FILES_FAILURE = 'UPLOAD_FILES_FAILURE';

export const DESTROY_FILE_START = 'DESTROY_FILE_START';
export const DESTROY_FILE_SUCCESS = 'DESTROY_FILE_SUCCESS';
export const DESTROY_FILE_FAILURE = 'DESTROY_FILE_FAILURE';

export const NOTIFICATION_START = 'NOTIFICATION_START';
export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
export const NOTIFICATION_FAILURE = 'NOTIFICATION_FAILURE';

export const NUMBER_PER_STATUS_START = 'NUMBER_PER_STATUS_START';
export const NUMBER_PER_STATUS_SUCCESS = 'NUMBER_PER_STATUS_SUCCESS';
export const NUMBER_PER_STATUS_FAILURE = 'NUMBER_PER_STATUS_FAILURE';

export const USABLE_ACTIONS_START = 'USABLE_ACTIONS_START';
export const USABLE_ACTIONS_SUCCESS = 'USABLE_ACTIONS_SUCCESS';
export const USABLE_ACTIONS_FAILURE = 'USABLE_ACTIONS_FAILURE';

export const ATTACHMENT_FILE_DOWNLOAD_START = 'ATTACHMENT_FILE_DOWNLOAD_START';
export const ATTACHMENT_FILE_DOWNLOAD_SUCCESS = 'ATTACHMENT_FILE_DOWNLOAD_SUCCESS';
export const ATTACHMENT_FILE_DOWNLOAD_FAILURE = 'ATTACHMENT_FILE_DOWNLOAD_FAILURE';

export const CLEAR_CREATED_FORM_ID = 'CLEAR_CREATED_FORM_ID';
export const CLEAR_CREATED_AFTER_SUCCESS = 'CLEAR_CREATED_AFTER_SUCCESS';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'FATAL_FAILURE';
export const CLEAR_APPLICATION_FORM_ERROR = 'CLEAR_APPLICATION_FORM_ERROR';
